import type { DocumentRepository } from "../repositories/document-repository"

export const makeCancelAllDocuments =
  (repo: DocumentRepository) => (kbId: string) =>
    repo.cancelAll(kbId)
